import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import styles from './Badge.module.css';
import { BadgeProps } from './types';
function Badge(t0) {
  const $ = _c(8);
  const {
    kind: t1,
    children,
    className,
    as: t2,
    id
  } = t0;
  const kind = t1 === undefined ? "default" : t1;
  const as = t2 === undefined ? "div" : t2;
  const Tag = as;
  const t3 = styles[kind];
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = classNames(styles.container, t3, className);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== Tag || $[4] !== children || $[5] !== id || $[6] !== t4) {
    t5 = <Tag className={t4} id={id}>{children}</Tag>;
    $[3] = Tag;
    $[4] = children;
    $[5] = id;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
export default Badge;